<template>
    <div>
        <v-file-input
            v-model="innerValue"
            v-bind="$attrs"
            @change="onFileChange"
        />

        <v-img
            v-if="url"
            :src="url"
            max-height="300"
            max-width="400"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [File, null],
                required: false,
                default: null,
            },
        },
        data: () => ({
            url: null,
        }),
        computed: {
            innerValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
        },
        methods: {
            onFileChange(file) {
                if (!file) {
                    this.url = null;
                } else {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.url = reader.result;
                    };
                    reader.onerror = (error) => {
                        console.error('Error: ', error);
                        this.url = null;
                    };
                }
            },
        },
    };
</script>
